<script>
export default {
    name: "FeedbackBrandsBadge"
}
</script>

<template>
    <div class="container relative z-2">
        <div class="bg-white shadow-xl rounded-lg border border-gray-200">
            <div class="flex items-center w-full pt-5 pb-5 ps-5 lg:ps-20 pe-5 lg:pe-20 ">
                <div class="overflow-hidden w-full">
                    <div
                        class="scrolling-wrapper grid grid-cols-3 lg:grid-cols-6 items-center gap-10 justify-between w-full">
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/yandex.webp"
                                 class="max-h-[45px]"
                                  alt="yandex" title="yandex"/>
                        </a>
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/2gis.webp"
                                 class="max-h-[45px]"
                                  alt="2gis" title="2gis"/>
                        </a>
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/google.webp"
                                 class="max-h-[45px]"
                                  alt="google" title="google"/>
                        </a>
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/zoon.webp"
                                 class="max-h-[45px]"
                                  alt="zoon" title="zoon"/>
                        </a>
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/yell.webp"
                                 class="max-h-[45px]"
                                  alt="yell" title="yell"/>
                        </a>
                        <a href="#" class="flex justify-center" target="_blank">
                            <img src="@img/brands/big/flamp.webp"
                                 class="max-h-[45px]"
                                  alt="flamp" title="flamp"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.z-2 {
    z-index: 2;
}
</style>
